import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";

const ArrowLeft = (props: SvgComponentProps) => {
  const { width = 20, height = 20, color = "#00A49F", widthBoxView, heightBoxView } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${widthBoxView || width} ${heightBoxView || height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.5 15.8333L2.5 10.8333M2.5 10.8333L7.5 5.83333M2.5 10.8333H17.5"
          stroke={color}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgWrapper>
  );
};

export default ArrowLeft;
